import { ForkLiftJobStatus } from "@gtpl/shared-models/warehouse-management";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsEnum, IsOptional } from "class-validator";
export class ForkLiftUpdateRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    jobId: number;
    @ApiProperty()
    targetPosition: number;
    @ApiProperty()
    realPosition: number;
    @ApiProperty()
    @IsOptional()
    deviceName: string;
    @ApiProperty()
    @IsOptional()
    userName: string;
    @ApiProperty()
    updatedAt: Date;    
    @ApiProperty()
    updatedUser: string; 
  }